import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';
import Feather from 'react-native-vector-icons/Feather';
import {InstallmentVariant} from '../../dtos/EmprestimoDTO';

export const Container = styled.View`
 flex:1;
  background-color: ${({theme}) => theme.colors.background};
`;

export const ContentHeader = styled.View`
  flex-direction: row;
  align-items: center;
  padding: 0 24px;
  justify-content: space-between;
`;

export const Title = styled.Text`
  color: ${({theme}) => theme.colors.text_dark};
  font-size: ${RFValue(14)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const LoanSectionTitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(16)}px;
  color: ${({theme}) => theme.colors.title};
  margin: ${RFValue(16)}px 24px ${RFValue(8)}px;
`;

export const LoanInstallmentBlock = styled.TouchableOpacity<{
  variant: InstallmentVariant;
}>`
  padding: ${RFValue(8)}px ${RFValue(12)}px;
  background-color: ${({theme, variant}) => {
    if (variant === 'atrasado') {return theme.colors.attention_opacity;}
    if (variant === 'atencao') {return theme.colors.gold_opacity;}
    return 'transparent';
  }};
  border-width: ${({variant}) =>
    variant === 'pago' || variant === 'quitado' ? 0 : 1}px;
  border-color: ${({theme, variant}) => {
    if (variant === 'atrasado') {return theme.colors.attention;}
    if (variant === 'atencao') {return theme.colors.gold;}
    return 'transparent';
  }};
`;

export const LoanInstallmentDivider = styled.View<{
  variant: InstallmentVariant;
}>`
  height: 1px;
  background-color: ${({theme, variant}) => {
    if (variant === 'atrasado') {return theme.colors.attention;}
    if (variant === 'atencao') {return theme.colors.gold;}
    return theme.colors.border;
  }};
`;

export const LoanInstallmentLink = styled.Text<{variant: InstallmentVariant}>`
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(11)}px;
  text-decoration-line: underline;
  color: ${({theme, variant}) => {
    if (variant === 'atrasado') {return theme.colors.attention;}
    if (variant === 'atencao') {return theme.colors.gold_dark;}
    return theme.colors.primary;
  }};
`;

export const EmptyStateContainer = styled.View`
  align-items: center;
  margin: ${RFValue(12)}px 24px ${RFValue(8)}px;
  padding: ${RFValue(28)}px ${RFValue(24)}px;
  border-radius: ${RFValue(14)}px;
  border-width: 1px;
  border-color: ${({theme}) => theme.colors.border};
  border-style: dashed;
  background-color: ${({theme}) => theme.colors.price_card};
`;

export const EmptyStateIconWrapper = styled.View`
  width: ${RFValue(56)}px;
  height: ${RFValue(56)}px;
  border-radius: ${RFValue(28)}px;
  background-color: ${({theme}) => theme.colors.primary_light};
  align-items: center;
  justify-content: center;
  margin-bottom: ${RFValue(14)}px;
`;

export const EmptyStateIcon = styled(Feather)`
  font-size: ${RFValue(26)}px;
  color: ${({theme}) => theme.colors.primary};
`;

export const EmptyStateTitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(14)}px;
  color: ${({theme}) => theme.colors.title};
  text-align: center;
  margin-bottom: ${RFValue(6)}px;
`;

export const EmptyStateText = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.text};
  text-align: center;
  line-height: ${RFValue(18)}px;
`;

/* ─── Alert Banner ─── */

interface AlertBannerProps {
  color?: 'red' | 'orange' | 'blue';
}

export const AlertBanner = styled.TouchableOpacity<AlertBannerProps>`
  flex-direction: row;
  align-items: flex-start;
  border-radius: ${RFValue(10)}px;
  border-width: 1px;
  padding: ${RFValue(12)}px ${RFValue(14)}px;
  margin: ${RFValue(12)}px 24px 0;
  gap: ${RFValue(10)}px;
  background-color: ${({theme, color}) => {
    if (color === 'orange') {return theme.colors.alert_orange_bg;}
    if (color === 'blue') {return theme.colors.alert_blue_bg;}
    return theme.colors.alert_red_bg;
  }};
  border-color: ${({theme, color}) => {
    if (color === 'orange') {return theme.colors.alert_orange_border;}
    if (color === 'blue') {return theme.colors.alert_blue_border;}
    return theme.colors.alert_red_border;
  }};
`;

export const AlertBannerIcon = styled(Feather)<AlertBannerProps>`
  font-size: ${RFValue(16)}px;
  margin-top: ${RFValue(1)}px;
  color: ${({theme, color}) => {
    if (color === 'orange') {return theme.colors.alert_orange_icon;}
    if (color === 'blue') {return theme.colors.alert_blue_icon;}
    return theme.colors.alert_red_icon;
  }};
`;

export const AlertBannerText = styled.Text`
  flex: 1;
  font-family: ${({theme}) => theme.fonts.regular};
  font-size: ${RFValue(11)}px;
  color: ${({theme}) => theme.colors.text_dark};
  line-height: ${RFValue(17)}px;
`;

export const AlertBannerBold = styled.Text<AlertBannerProps>`
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme, color}) => {
    if (color === 'orange') {return theme.colors.alert_orange_title;}
    if (color === 'blue') {return theme.colors.alert_blue_title;}
    return theme.colors.alert_red_title;
  }};
`;

/* ─── Tab Menu ─── */

export const TabRow = styled.View`
  flex-direction: row;
  align-items: center;
  margin: ${RFValue(0)}px 24px 0;
  margin-top: ${RFValue(8)}px;
`;

export const TabContainer = styled.View`
  flex: 1;
  flex-direction: row;
  background-color: ${({theme}) => theme.colors.background_secondary};
  border-radius: ${RFValue(12)}px;
  padding: ${RFValue(3)}px;
`;

export const RefreshButton = styled.TouchableOpacity`
  justify-content: flex-end;
  align-items: flex-end;
  padding: ${RFValue(12)}px 24px 0;
  flex-direction: row;
  align-items: center;
  gap: ${RFValue(6)}px;
`;

export const RefreshButtonIcon = styled(Feather)`
  font-size: ${RFValue(18)}px;
  color: ${({theme}) => theme.colors.text};
`;

export const RefreshButtonText = styled.Text`
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.text};
`;

export const TabButton = styled.TouchableOpacity<{active: boolean}>`
  flex: 1;
  padding: ${RFValue(10)}px 0;
  align-items: center;
  justify-content: center;
  border-radius: ${RFValue(10)}px;
  background-color: ${({theme, active}) =>
    active ? theme.colors.shape : 'transparent'};
  elevation: ${({active}) => (active ? 2 : 0)};
  shadow-color: #000;
  shadow-offset: 0px ${({active}) => (active ? 1 : 0)}px;
  shadow-opacity: ${({active}) => (active ? 0.1 : 0)};
  shadow-radius: ${({active}) => (active ? 3 : 0)}px;
`;

export const TabLabelRow = styled.View`
  flex-direction: row;
  align-items: center;
  gap: ${RFValue(6)}px;
`;

export const TabLabel = styled.Text<{active: boolean}>`
  font-family: ${({theme, active}) =>
    active ? theme.fonts.semibold : theme.fonts.medium};
  font-size: ${RFValue(13)}px;
  color: ${({theme, active}) =>
    active ? theme.colors.primary : theme.colors.text};
`;

export const TabBadge = styled.View<{active: boolean}>`
  min-width: ${RFValue(18)}px;
  height: ${RFValue(18)}px;
  border-radius: ${RFValue(9)}px;
  padding: 0 ${RFValue(4)}px;
  align-items: center;
  justify-content: center;
  background-color: ${({theme}) => theme.colors.primary};
`;

export const TabBadgeText = styled.Text`
  font-family: ${({theme}) => theme.fonts.bold};
  font-size: ${RFValue(10)}px;
  color: ${({theme}) => theme.colors.buttonTitle};
`;

/* ─── Gate: Loading & Elegibilidade ─── */

export const GateCenter = styled.View`
  flex: 1;
  justify-content: center;
  align-items: center;
  padding: 0 ${RFValue(32)}px;
`;

export const GateLoadingTitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(16)}px;
  color: ${({theme}) => theme.colors.loan_banner_bg};
  margin-top: ${RFValue(20)}px;
  text-align: center;
`;

export const GateLoadingSubtitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.text};
  margin-top: ${RFValue(8)}px;
  text-align: center;
`;

export const GateErrorIconWrapper = styled.View`
  width: ${RFValue(64)}px;
  height: ${RFValue(64)}px;
  border-radius: ${RFValue(32)}px;
  background-color: ${({theme}) => theme.colors.attention_opacity};
  align-items: center;
  justify-content: center;
  margin-bottom: ${RFValue(20)}px;
`;

export const GateErrorIcon = styled(Feather)`
  font-size: ${RFValue(28)}px;
  color: ${({theme}) => theme.colors.attention};
`;

export const GateErrorTitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.bold};
  font-size: ${RFValue(18)}px;
  color: ${({theme}) => theme.colors.title};
  margin-bottom: ${RFValue(12)}px;
  text-align: center;
`;

export const GateErrorText = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  font-size: ${RFValue(13)}px;
  color: ${({theme}) => theme.colors.text};
  text-align: center;
  line-height: ${RFValue(22)}px;
`;
